import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  title: t.Str,
  image: t.Str,
  onClick: t.Func
})
export default class AdvBox extends React.Component {

  render() {
    const { title } = this.props;
    return (
      <div className="adv_box border-radius-all" onClick={this.props.onClick}>
        <img alt={title} src={this.props.image}/>
        <div className="caption">
          <h1>{title}</h1>
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/AdvBox.js
 **/